module.exports = __webpack_public_path__ + "static/img/n_logo.9bc4c489.png";